import React, { useEffect } from 'react';
import MiniTrackComponent from './MiniTrackComponent.js';
import ConditionedComponent from 'components/ConditionedComponent.js';

export default function WarpDocumentation(props) {
    function switchToHiHat() {
        props.sequencerEngine.scripting.viCommand('d');
        props.sequencerEngine.scripting.viCommand('d');
        props.sequencerEngine.switchToSubSequence(
            props.sequencerEngine.subSequences[0].id);
    }

    function onClickSwitch() {
        switchToHiHat();
        props.sequencerEngine.getSelectedTrack().warp();
        props.sequencerEngine.getSelectedTrack().showEffects(true);
        clearAndToggle();
        window.scroll(0,0);
    }

    function clearAndToggle() {
        props.sequencerEngine.scripting.viCommand('d');
        props.sequencerEngine.scripting.viCommand('d');
        props.sequencerEngine.scripting.viCommand('t');
        for (let i=0; i < 16; i++) {
            props.sequencerEngine.scripting.viCommand('o');
        }
    }

    useEffect(() => {
        if (props.sequencerEngine.subSequences[1] !== undefined) {
            props.sequencerEngine.switchToSubSequence(
                props.sequencerEngine.subSequences[1].id);
        }

        props.sequencerEngine.scripting.viCommand('d');
        props.sequencerEngine.scripting.viCommand('d');
        props.sequencerEngine.scripting.viCommand('t');
        for (let i=0; i < 16; i++) {
            props.sequencerEngine.scripting.viCommand('o');
        }

        return switchToHiHat;
    }, [0]);

    return (
        <div>
          <p>
            The <b>Warp</b> midi-effect's main purpose is to sync a sample's tempo to the tempo of the project.
          </p>
          <p>
            Click the "Warp" button below the track's thumbnail to enable warping on that track.
          </p>
          <MiniTrackComponent sequencerEngine={props.sequencerEngine}/>
          <p>
            Click the <b>FX</b> button and notice a new midi-effect called <b>Warp</b> in your effects chain. The drum break is automatically synced to the tempo (i.e. it doesn't trip over itself).
          </p>
          <p>
            <b>Warp</b> has numerous parameters for refining the timing of your sample.
          </p>
          <p className="sub-header">
            Warp Length
          </p>
          <p>
            When <b>Warp Length</b> set to 1, the sample will be in sync with the BPM of the project.
          </p>
          <p>
            For values above 1, it slows down the sample. Below 1, the sample speeds up. 
          </p>
          <p>
            This gives you a fine grained control for the tempo of a sample.
          </p>
          <p className="sub-header">
            Warp Factor
          </p>
          <p>
            <b>Warp Factor</b> factors the <b>Warp Length</b> proportionally to it's value. By default it is 2. So when set to 1, the sample will double in speed. When set to 4, the speed halves.
          </p>
          <p>
            Think of it as a coarse control over sample speed.
          </p>
          <p className="sub-header">
            Rate
          </p>
          <p>
            <b>Warp</b> works by slicing a sample into many grains and playing them at the <b>Rate</b> specified in the <b>Rate</b> parameter.
          </p>
          <p>
            By default, the <b>Rate</b> is set to 1/16th notes. However, you can set it to any resolution of notes for creative timing.
          </p>
          <p className="sub-header">
            Grain Size
          </p>
          <p>
            As mentioned, <b>Warp</b> slices the sample into grains and triggers them at the <b>Rate</b> specified. You can control the size of the grains using the <b>Grain Size</b> parameter. By default it is 1, which means one 1/16th note.
          </p>
          <p>
            Setting to lower values creates a more stuttering, almost tremolo effect.
          </p>
          <p className="sub-header">
            Smoothing
          </p>
          <p>
            You can control the crossover between grains using the <b>Smoothing</b> parameter. 
          </p>
          <p>
            This essentially applies a fade-in and fade-out to each grain, making the process smoother. This can smooth out the transients within a sample.
          </p>
          <p className="sub-header">
            Loop Length
          </p>
          <p>
            You can control the length of the loop cycle-- with respect to the entire length of the sample-- using the <b>Loop Length</b> parameter. 
          </p>
          <p>
            This parameter is very interesting when applied to one hits, with no BPM.
          </p>
          <p>
            Click this button and try messing with the <b>Loop Length</b> parameter to get a feel for it.
          </p>
          <div
            onClick={onClickSwitch}
            className="common-button pink-button">
            Switch to Hi-Hat
          </div>
          <div className="clear-fix"/>
          <p>
            The warping effectively creates a bunch of ghost hits stemming from the initial hit, creating a very human-like rhythm.
          </p>
          <p>
            Try it with kicks, hi-hats, sidesticks, claves for extra fun.
          </p>
          <p className="sub-header">
            Appendix: Retriggering
          </p>
          <p>
            When 2 steps have durations that overlap one another, the second step will not cause a retrigger of the hit. Instead, the second step will override the parameters from the first step. 
          </p>
          <p>
            For example, if the first step has <b>Velocity</b> of 1, and the second step has <b>Velocity</b> of 0.5, then once the second step is hit, the velocity of all of the remainding hits will be 0.5.
          </p>
        </div>
    );
}
